const state = {
  assemblyList: "",
  tsId: "",
  updataData: {}
};

const mutations = {
  setAssemblyList(store, val) {
    const stroedata = store;
    stroedata.assemblyList = val;
  },
  setTsId(store, val) {
    const stroedata = store;
    stroedata.tsId = val;
  },
  setupdataData(store, val) {
    const stroedata = store;
    console.log(val, "val");
    stroedata.updataData = val;
    console.log(stroedata.updataData, "updataData");
  }
};

const actions = {
  setAssemblyList({ commit }, assemblyList) {
    commit("setAssemblyList", assemblyList);
  },
  setTsId({ commit }, tsId) {
    commit("setTsId", tsId);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
